(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VTree", [], factory);
	else if(typeof exports === 'object')
		exports["VTree"] = factory();
	else
		root["VTree"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aca0bdf6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tree_vue__ = __webpack_require__(19);
function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aca0bdf6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treeUl__ = __webpack_require__(3);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Tree",
  inheritAttrs: false,
  components: { TreeUl: __WEBPACK_IMPORTED_MODULE_0__treeUl__["default"] },
  provide: function provide() {
    return {
      isLeaf: this.isLeaf,
      childChecked: this.childCheckedHandle,
      parentChecked: this.parentCheckedHandle,
      emitEventToTree: this.emitEventToParent,
      nodeSelected: this.nodeSelected,
      setAttr: this.setAttr
    };
  },
  data: function data() {
    return {
      radioNode: null // 单选节点
    };
  },

  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    halfcheck: {
      type: Boolean,
      default: false
    },
    canDeleteRoot: {
      type: Boolean,
      default: false
    },
    maxLevel: {
      // 最大层级
      type: Number,
      default: 1024
    },
    topMustExpand: {
      // 首层必须可以展开
      type: Boolean,
      default: true
    },
    allowGetParentNode: {
      // 允许获取父节点
      type: Boolean,
      default: false
    },
    radio: {
      // 单选, selected节点至多可以选一个
      type: Boolean,
      default: false
    },
    selectAlone: {
      // select事件不影响checkbox
      type: Boolean,
      default: false
    },
    allowCheckedChildrenOfDisabledChild: {
      type: Boolean,
      default: true
    }
  },
  beforeCreate: function beforeCreate() {
    // 默认为false
    this.$defVal = {
      visible: true
    };
  },

  computed: {
    childBind: function childBind() {
      return Object.assign({}, this.$attrs, this.$props);
    }
  },
  methods: {
    // 通过依赖注入共享的方法
    /* @method Determine whether it is a leaf node
     * @param node current node
     */
    isLeaf: function isLeaf(node) {
      return !(node.children && node.children.length);
    },
    childCheckedHandle: function childCheckedHandle(node, checked) {
      var _this = this;

      var halfcheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var children = node.children;

      if (children && children.length) {
        children.forEach(function (child) {
          if (!child.chkDisabled) {
            _this.$set(child, "checked", checked);
            if (halfcheck) {
              _this.$set(child, "halfcheck", false);
            }
            _this.$set(child, "parentCheckedToChildren", true);
          }
          if (_this.allowCheckedChildrenOfDisabledChild) {
            _this.childCheckedHandle(child, checked, halfcheck);
          }
        });
      }
    },
    parentCheckedHandle: function parentCheckedHandle(parentNode, checked) {
      var halfcheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!parentNode || parentNode.chkDisabled) return false;
      var someBortherNodeChecked = checked,
          allBortherNodeChecked = checked;
      var childNodes = parentNode.children;
      if (checked) {
        allBortherNodeChecked = childNodes.every(function (child) {
          return child.checked;
        });
      } else {
        someBortherNodeChecked = childNodes.some(function (_ref) {
          var checked = _ref.checked,
              itemHalfCheck = _ref.halfcheck;

          return checked || halfcheck && itemHalfCheck;
        });
      }
      if (halfcheck) {
        // all / some / none
        var nodeHalfcheck = checked ? !allBortherNodeChecked : someBortherNodeChecked;
        var _parentNode$halfcheck = parentNode.halfcheck,
            oldHalfCheck = _parentNode$halfcheck === undefined ? false : _parentNode$halfcheck;

        if (oldHalfCheck !== nodeHalfcheck) {
          this.$set(parentNode, "halfcheck", nodeHalfcheck);
        } else if (nodeHalfcheck) {
          return false;
        }
        this.$set(parentNode, "checked", allBortherNodeChecked);
      } else {
        this.$set(parentNode, "checked", allBortherNodeChecked);
      }
      return true;
    },
    emitEventToParent: function emitEventToParent(eventName) {
      if (!eventName) return;
      // 为了让接口更清晰
      if ("node-mouse-over" != eventName) switch (eventName) {
        case "node-mouse-over":
        case "node-check":
        case "drag-node-end":
        case "del-node":
        case "node-click":
        case "node-select": // 和 'node-click'一样,为了更好的语义化
        case "async-load-nodes":
        case "node-expand":
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          this.$emit.apply(this, [eventName].concat(_toConsumableArray(args)));
          break;
        default:
          throw new ReferenceError("the event of " + eventName + " is not effective");
      }
    },

    // 设置node属性
    setAttr: function setAttr(node, attr) {
      var val = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var _node$attr = node[attr],
          defVal = _node$attr === undefined ? this._getDefVal(attr) : _node$attr;

      if (defVal !== val) {
        this.$set(node, attr, val);
      }
    },
    setAttrs: function setAttrs(node) {
      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var val = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var setAttr = this.setAttr;
      attrs.forEach(function (attr) {
        return setAttr(node, attr, val);
      });
    },

    // 内部使用方法
    updateRadioNode: function updateRadioNode(node) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!selected) return;
      var previousNode = this.radioNode;
      if (previousNode) {
        this.setNodeAttr(previousNode, "selected", !selected);
      }
      this.radioNode = node;
    },

    // 对外暴露的方法,通过ref访问

    // set node attr
    setNodeAttr: function setNodeAttr(node, attr) {
      var val = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!node || !attr) return;
      if (node.hasOwnProperty(attr)) {
        this.setAttr(node, attr, val);
      } else {
        this.$set(node, attr, val);
      }
    },

    /*
     *@method change the node selected  method
     *@param node current node
     */
    nodeSelected: function nodeSelected(node, position) {
      var selected = !node.selected;
      var changeCheck = this.multiple && !this.selectAlone;
      if (changeCheck) {
        this.$set(node, "checked", selected);
      }
      if (this.radio) {
        this.updateRadioNode(node, selected);
      }
      this.$set(node, "selected", selected); // 只对当前的selected属性有效
      if (changeCheck) {
        this.childCheckedHandle(node, selected, this.halfcheck);
      }
      this.emitEventToParent("node-click", node, selected, position);
      this.emitEventToParent("node-select", node, selected, position);
    },


    /* @method adding child node
     * @param node parent node
     * @param newnode  new node
     */
    addNode: function addNode(parent, newNode) {
      if (!parent) return;
      var addnode = null;
      this.$set(parent, "expanded", true);
      var newNodeType = typeof newNode === "undefined" ? "undefined" : _typeof(newNode);
      if (newNodeType === "undefined") {
        throw new ReferenceError("newNode is required but undefined");
      } else if (newNodeType === "string") {
        addnode = { title: newNode };
      } else if (newNodeType === "object") {
        if (!newNode.hasOwnProperty("title")) {
          throw new ReferenceError("the title property is missed");
        } else {
          addnode = newNode;
        }
      } else {
        throw new ReferenceError("newNode type error, not allowed " + newNodeType);
      }
      var halfcheck = parent.halfcheck,
          checked = parent.checked;

      addnode = Object.assign({
        checked: !halfcheck && checked
      }, addnode);
      if (this.isLeaf(parent)) {
        this.$set(parent, "children", []);
        parent.children.push(addnode);
      } else {
        parent.children.push(addnode);
      }
    },


    /* @method adding childlren nodes
     * @param node parent node
     * @param newnode  new node
     */
    addNodes: function addNodes(parent, children) {
      if (!parent) return;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var n = _step.value;

          this.addNode(parent, n);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },


    /* @method delete a node
     * @param  parent parent node
     * @param  node current node
     */
    delNode: function delNode(node, parent, index) {
      if (parent === null || typeof parent === "undefined") {
        if (this.canDeleteRoot) {
          this.data.splice(index, 1);
        } else {
          throw new ReferenceError("the root element can't deleted!");
        }
      } else {
        parent.children.splice(index, 1);
      }
      // this.$emit('delNode', { parentNode: parent, delNode: node })
      this.emitEventToParent("del-node", { parentNode: parent, delNode: node });
    },


    /*
     *@method get Nodes by options method
     *@param data nodes
     *@param opt the options that filter the node
     */
    getNodes: function getNodes() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = arguments[1];
      var isOriginal = arguments[2];
      var ignoreInvisibleNode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var optArr = Object.entries(opt);
      var hasOpt = optArr.length > 0;
      return this._getNodes(optArr, hasOpt, data, isOriginal, ignoreInvisibleNode);
    },


    // opt: Array
    _getNodes: function _getNodes(opt, hasOpt) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.data;
      var isOriginal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var ignoreInvisibleNode = arguments[4];
      var res = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

      // let res = []
      var _pushNode = function _pushNode(arr, node, isOrg) {
        if (isOrg) {
          arr.push(node);
        } else {
          var n = Object.assign({}, node);
          Reflect.deleteProperty(n, "hasExpanded");
          Reflect.deleteProperty(n, "children");
          Reflect.deleteProperty(n, "parent");
          arr.push(n);
        }
      };
      var pushNode = function pushNode(node) {
        return _pushNode(res, node, isOriginal);
      };
      // is a node matched the condition
      var getDefVal = this._getDefVal;
      var _isMatchedNode = function _isMatchedNode(node, condition) {
        var matched = true;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = condition[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ref2 = _step2.value;

            var _ref3 = _slicedToArray(_ref2, 2);

            var attr = _ref3[0];
            var val = _ref3[1];

            if (node.hasOwnProperty(attr)) {
              var _node$attr2 = node[attr],
                  nodeVal = _node$attr2 === undefined ? getDefVal(attr) : _node$attr2;

              matched = nodeVal === val;
            } else {
              matched = false;
            }
            if (!matched) break;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return matched;
      };
      var isMatchedNode = function isMatchedNode(node) {
        return _isMatchedNode(node, opt);
      };

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var node = _step3.value;
          var children = node.children,
              _node$visible = node.visible,
              visible = _node$visible === undefined ? true : _node$visible;

          if (ignoreInvisibleNode && !visible) {
            continue;
          }
          if (hasOpt) {
            if (isMatchedNode(node)) {
              pushNode(node);
            }
          } else {
            pushNode(node);
          }
          if (children && children.length) {
            this._getNodes(opt, hasOpt, children, isOriginal, ignoreInvisibleNode, res);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return res;
    },


    /*
     *@method get Nodes that selected
     */
    getSelectedNodes: function getSelectedNodes(isOriginal) {
      var ignoreInvisibleNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return this.getNodes({ selected: true }, this.data, isOriginal, ignoreInvisibleNode);
    },


    /*
     *@method get Nodes that checked
     */
    getCheckedNodes: function getCheckedNodes(isOriginal) {
      var ignoreInvisibleNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return this.getNodes({ checked: true }, this.data, isOriginal, ignoreInvisibleNode);
    },

    /*
     *@method filter nessary nodes methods
     *@param filter string or predicate expression
     *@param data current nodes
     */
    searchNodes: function searchNodes(filter) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.data;

      if (filter == null || typeof filter === "string" && filter.trim() === "") {
        data.forEach(function (node) {
          return _this2._modifyAllNode(node);
        });
        return;
      }
      var filterFn = typeof filter === "function" ? filter : function () {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref4$title = _ref4.title,
            title = _ref4$title === undefined ? "" : _ref4$title;

        return title.includes(filter);
      };
      var searchRes = Array.from({ length: data.length }, function () {
        return [];
      });
      data.forEach(function (node, index) {
        var matched = searchRes[index];
        _this2._searchNodes(filterFn, node, index, matched);
        if (matched.length > 0) {
          matched.sort(function (x, y) {
            return x.length - y.length;
          }); // 根据长度升序
          var attrs = ["visible", "expanded"];
          if (matched.some(function (x) {
            return x.length === 1;
          })) {
            attrs.push("searched");
          }
          _this2.setAttrs(node, attrs);
          _this2._showSearchNodes(node, matched.map(function (x) {
            return x.slice(1);
          }).filter(function (x) {
            return x.length;
          }));
        } else {
          _this2.setAttr(node, "visible", false);
        }
      });
    },
    _searchNodes: function _searchNodes(filterFn, node, index, matched) {
      var path = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

      var isMatched = filterFn(node);
      path = [].concat(_toConsumableArray(path), [index]);
      if (isMatched) {
        // 如果titile的内容是html,html内容也能被搜索到
        matched.push(path);
      }
      // this.$set(node, 'searched', searched)
      // this.$set(node, 'visible', false)
      var children = node.children;

      if (children && children.length) {
        // if (searched) this.$set(node, 'expanded', true) // 展开
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = children.entries()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _ref5 = _step4.value;

            var _ref6 = _slicedToArray(_ref5, 2);

            var i = _ref6[0];
            var _node = _ref6[1];

            this._searchNodes(filterFn, _node, i, matched, path);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    },
    _getDefVal: function _getDefVal(attr) {
      return this.$defVal[attr] || false;
    },
    _dedupe: function _dedupe(arr) {
      return [].concat(_toConsumableArray(new Set(arr)));
    },
    _showSearchNodes: function _showSearchNodes(node, matched) {
      var _this3 = this;

      matched = matched.map(function (path) {
        return [].concat(_toConsumableArray(path));
      });
      var setAttrs = this.setAttrs;
      var dedupe = this._dedupe;
      var isSame = true;

      var _loop = function _loop() {
        var _node2 = node,
            children = _node2.children;
        // 将长度为1的匹配路径设置为'searched'

        var newMatched = [];
        var searchedPaths = matched.filter(function (x) {
          var len = x.length;
          if (len > 1) {
            newMatched.push(x);
          }
          return len === 1;
        });
        searchedPaths.forEach(function (path) {
          setAttrs(children[path[0]], ["visible", "expanded", "searched"]);
        });
        var samePaths = dedupe(matched.map(function (item) {
          return item[0];
        }));
        var len = samePaths.length;
        if (len !== children.length) {
          children.forEach(function (childNode, i) {
            if (!samePaths.includes(i)) {
              _this3.setAttr(childNode, "visible", false);
            }
          });
        }
        if (newMatched.length > 0) {
          if (len === 1) {
            matched = newMatched.map(function (x) {
              return x.slice(1);
            });
            node = children[samePaths[0]];
            setAttrs(node, ["visible", "expanded"]);
          } else {
            samePaths.forEach(function (pathIndex) {
              var childNode = children[pathIndex];
              setAttrs(childNode, ["visible", "expanded"]);
              _this3._showSearchNodes(childNode, matched.filter(function (x) {
                return x[0] === pathIndex && x.length > 1;
              }).map(function (x) {
                return x.slice(1);
              }));
            });
            isSame = false;
          }
        } else {
          isSame = false;
        }
      };

      while (isSame && matched.length > 0) {
        _loop();
      }
    },
    _modifyAllNode: function _modifyAllNode(node) {
      var _this4 = this;

      var attrsObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { visible: true, searched: false };
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = Object.entries(attrsObj)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _ref7 = _step5.value;

          var _ref8 = _slicedToArray(_ref7, 2);

          var key = _ref8[0];
          var val = _ref8[1];

          this.setAttr(node, key, val);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var children = node.children;

      if (children && children.length > 0) {
        children.forEach(function (node) {
          return _this4._modifyAllNode(node, attrsObj);
        });
      }
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_treeUl_vue__ = __webpack_require__(4);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61df22b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_treeUl_vue__ = __webpack_require__(18);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_treeUl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61df22b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_treeUl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treeLi__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(6);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

//
//
//
//
//
//
//
//
//
//
//
//


// import './tree.css'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TreeUl',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */]],
  inheritAttrs: false,
  components: { TreeLi: __WEBPACK_IMPORTED_MODULE_0__treeLi__["a" /* default */] },
  inject: ['isLeaf', 'childChecked', 'parentChecked', 'emitEventToTree'],
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    dragAfterExpanded: {
      type: Boolean,
      default: true
    },
    level: {
      type: Number,
      default: 0
    },
    allowGetParentNode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    childBind: function childBind() {
      var _$props = this.$props,
          data = _$props.data,
          otherObj = _objectWithoutProperties(_$props, ['data']);

      var dataLength = data.filter(function (node) {
        return node.visible !== false;
      }).length;
      return Object.assign({}, this.$attrs, otherObj, {
        dataLength: dataLength,
        level: this.treeLevel
      });
    },
    treeLevel: function treeLevel() {
      return this.level + 1;
    }
  },
  methods: {
    /* @method drop node
     * @param node droped node
     * @param ev  $event
    */
    drop: function drop(node, ev) {
      ev.preventDefault();
      ev.stopPropagation();
      var guid = ev.dataTransfer.getData('guid');

      var _getDragNode = this.getDragNode(guid),
          dragNode = _getDragNode.node,
          parentNode = _getDragNode.parent;
      // if drag node's parent is enter node or root node


      if (parentNode === node || parentNode === null || dragNode === node) return false;
      // drag from parent node to child node
      if (this.hasInGenerations(dragNode, node)) return false;
      var dragHost = parentNode.children;
      if (node.children && node.children.indexOf(dragNode) === -1) {
        node.children.push(dragNode);
        dragHost.splice(dragHost.indexOf(dragNode), 1);
      } else {
        this.$set(node, 'children', [dragNode]);
        dragHost.splice(dragHost.indexOf(dragNode), 1);
      }
      this.$set(node, 'expanded', this.dragAfterExpanded);
      this.dragNodeEnd({ dragNode: dragNode, targetNode: node, event: ev });
    },

    /* @method drag node
     * @param node draged node
     * @param ev  $event
    */
    drag: function drag(node, ev) {
      var guid = this.guid();
      this.setDragNode(guid, node, this.parent);
      ev.dataTransfer.setData('guid', guid);
    },

    /* @method dragover node
     * @param ev  $event
    */
    dragover: function dragover(ev) {
      ev.preventDefault();
      ev.stopPropagation();
    },

    /* @event passing the drag-node-end event to the parent component
     * @param node clicked node
     */
    dragNodeEnd: function dragNodeEnd() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.emitEventToTree('drag-node-end', obj);
    }
  },
  created: function created() {
    if (this.allowGetParentNode === true) {
      var data = this.data;
      var hasParent = data[0] && typeof data[0].parent === 'function';
      if (!hasParent) {
        var parent = this.parent;
        this.data.forEach(function (item) {
          item.parent = function () {
            return parent;
          };
        });
      }
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__render__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collapse_transition__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TreeLi",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  components: {
    Render: __WEBPACK_IMPORTED_MODULE_1__render__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_2__loading__["a" /* default */],
    CollapseTransition: __WEBPACK_IMPORTED_MODULE_3__collapse_transition__["a" /* default */]
    // TreeUl: () => import('./treeUl.vue') // 解决循环引用的问题
  },
  beforeCreate: function beforeCreate() {
    this.$options.components.TreeUl = __webpack_require__(3).default;
  },

  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    index: Number,
    dataLength: {
      type: Number,
      default: 0
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    dragAfterExpanded: {
      type: Boolean,
      default: true
    },
    halfcheck: {
      type: Boolean,
      default: false
    },
    scoped: {
      type: Boolean,
      default: false
    },
    canDeleteRoot: {
      type: Boolean,
      default: false
    },
    tpl: Function,
    maxLevel: Number,
    level: Number,
    topMustExpand: Boolean,
    allowGetParentNode: Boolean
  },
  inject: ["isLeaf", "childChecked", "parentChecked", "nodeSelected", "emitEventToTree", "setAttr"],
  computed: {
    itemVisible: function itemVisible() {
      var _item$visible = this.item.visible,
          visible = _item$visible === undefined ? true : _item$visible;

      return visible;
    },
    hasExpanded: function hasExpanded() {
      // 已经展开过
      var _item = this.item,
          _item$hasExpanded = _item.hasExpanded,
          hasExpanded = _item$hasExpanded === undefined ? false : _item$hasExpanded,
          _item$expanded = _item.expanded,
          expanded = _item$expanded === undefined ? false : _item$expanded;

      return this.itemVisible && (expanded || hasExpanded);
    },
    liClass: function liClass() {
      var index = this.index;
      var res = void 0;
      if (this.parent) {
        res = {
          leaf: this.isLeaf(this.item)
        };
      } else {
        // top node
        res = {
          "first-node": index === 0,
          "only-node": this.dataLength === 1,
          "second-node": index === 1
        };
      }
      return res;
    },
    hasChildren: function hasChildren() {
      var item = this.item;
      return item.children && item.children.length > 0;
    },
    showExpand: function showExpand() {
      var item = this.item;
      var isShow = !this.parent ? this.topMustExpand : false;
      return isShow || this.hasChildren || item.async;
    },
    showNextUl: function showNextUl() {
      return !this.isLeaf(this.item) && this.maxLevel > this.level && this.hasExpanded;
    },
    position: function position() {
      return { level: this.level, index: this.index };
    },
    checkboxChecked: function checkboxChecked() {
      var _item2 = this.item,
          checked = _item2.checked,
          halfcheck = _item2.halfcheck;

      return checked || halfcheck;
    },
    spanInputClass: function spanInputClass() {
      var _item3 = this.item,
          checked = _item3.checked,
          halfcheck = _item3.halfcheck;

      return checked ? 'box-checked' : halfcheck ? 'box-halfchecked' : 'box-unchecked';
    }
  },
  watch: {
    "item.checked": {
      handler: function handler() {
        if (!this.scoped) {
          this.checkedChange();
        }
      },

      immediate: true
    },
    "item.halfcheck": {
      handler: function handler() {
        this.checkedChange();
      },

      immediate: true
    }
  },
  methods: {
    /* @method drag node
     * @param node draged node
     * @param ev  $event
     */
    drag: function drag(node, ev) {
      var guid = this.guid();
      this.setDragNode(guid, node, this.parent);
      ev.dataTransfer.setData("guid", guid);
    },

    /* @method expand or close node
     * @param node current node
     */
    expandNode: function expandNode(node) {
      var expended = !node.expanded;
      this.setAttr(node, "expanded", expended);
      this.setAttr(node, "hasExpanded", true);
      if (node.async && !node.children) {
        this.emitEventToTree("async-load-nodes", node);
      }
      this.emitEventToTree("node-expand", node, expended, this.position);
    },

    /* @event passing the node-check event to the parent component
     * @param node clicked node
     */
    nodeCheck: function nodeCheck(node, checked) {
      this.$set(node, "checked", checked);
      if (!this.scoped) {
        var halfcheck = this.halfcheck;
        if (halfcheck) {
          this.$set(node, "halfcheck", false);
        }
        this.childChecked(node, checked, halfcheck);
      }
    },

    /* @event passing the node-mouse-over event to the parent component
     * @param node overed node
     */
    nodeMouseOver: function nodeMouseOver(node, index, parent) {
      this.emitEventToTree("node-mouse-over", node, index, parent);
      // this.$emit('node-mouse-over', node)
    },

    /*
     *@method change the check box status method
     *@param node current node
     *@param $event event object
     */
    changeNodeCheckStatus: function changeNodeCheckStatus(node, $event) {
      var checked = $event.target.checked;
      this.nodeCheck(node, checked);
      this.emitEventToTree("node-check", node, checked, this.position);
    },
    theParentChecked: function theParentChecked(checked, halfcheck) {
      var parentNode = this.parent;
      this.parentChecked(parentNode, checked, halfcheck);
    },
    checkedChange: function checkedChange() {
      var _item4 = this.item,
          _item4$checked = _item4.checked,
          checked = _item4$checked === undefined ? false : _item4$checked,
          _item4$parentCheckedT = _item4.parentCheckedToChildren,
          parentCheckedToChildren = _item4$parentCheckedT === undefined ? false : _item4$parentCheckedT;

      if (!this.scoped || !parentCheckedToChildren) {
        this.theParentChecked(checked, this.halfcheck);
      }
      if (parentCheckedToChildren) {
        this.$delete(this.item, 'parentCheckedToChildren');
      }
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

function setDragNode(guid, node, parent) {
  window['treeDrag'] = {};
  // window['treeDrag'][guid] = node
  window['treeDrag'][guid] = { node: node, parent: parent };
}

function getDragNode(guid) {
  return window['treeDrag'][guid];
}

function hasInGenerations(root, node) {
  var ret = false;
  if (root.hasOwnProperty('children') && root.children) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = root.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var rn = _step.value;

        if (rn === node) return true;
        if (rn.children) ret |= hasInGenerations(rn, node);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return ret;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    guid: guid,
    setDragNode: setDragNode,
    getDragNode: getDragNode,
    hasInGenerations: hasInGenerations
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tree-load-svg'
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tree__ = __webpack_require__(1);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'selectTree',
  model: {
    event: 'value-change'
  },
  inheritAttrs: false,
  components: { VTree: __WEBPACK_IMPORTED_MODULE_0__tree__["a" /* default */] },
  data: function data() {
    return {
      searchword: '',
      open: false,
      selectedItems: []
    };
  },

  watch: {
    selectedItems: function selectedItems() {
      this.$emit('value-change', this.selectedItems);
    }
  },
  mounted: function mounted() {
    this.selectedItems = this.value;
    this.initTreeStatus();
  },

  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    searchable: {
      type: Boolean,
      default: true
    },
    pleasechoosetext: {
      type: String,
      default: 'please choose...'
    },
    searchtext: {
      type: String,
      default: 'search...'
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    dragAfterExpanded: {
      type: Boolean,
      default: true
    },
    tpl: Function,
    searchFilter: Function
  },
  computed: {
    vTreeObj: function vTreeObj() {
      return this.$attrs;
    }
  },
  methods: {
    /* @event passing the async-load-nodes event to the parent component
    *  @param node clicked node
    */
    asyncLoadNodes: function asyncLoadNodes(node) {
      if (node.async && !node.children) {
        this.$emit('async-load-nodes', node);
      }
    },

    /* @event passing the node-click event to the parent component
     * @param node clicked node
     */
    nodeClick: function nodeClick(node, selected) {
      this.getNewSelectedNodes();
      this.$emit('node-click', node, selected);
    },
    getSelectedAndCheckedNodes: function getSelectedAndCheckedNodes() {
      var checkedNode = [];
      if (this.multiple) {
        checkedNode = this.$refs.dropTree.getCheckedNodes(true);
      }
      var selectedNode = this.$refs.dropTree.getSelectedNodes(true);
      return [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(selectedNode), _toConsumableArray(checkedNode)))));
    },
    getNewSelectedNodes: function getNewSelectedNodes() {
      var _this = this;

      this.$nextTick(function () {
        _this.selectedItems = _this.getSelectedAndCheckedNodes().map(function (x) {
          return x.title;
        });
      });
    },

    /*
    * delete node tag from input
    */
    rmNode: function rmNode(text, eventFromNode) {
      if (!eventFromNode) {
        var node = this.getSelectedAndCheckedNodes().find(function (x) {
          return x.title === text;
        });
        if (node) {
          this.$set(node, 'selected', false);
          this.$set(node, 'checked', false);
        }
      }
      this.getNewSelectedNodes();
    },


    /*
    * node check status change event
    */
    // nodeCheckStatusChange (node, checked) {
    nodeCheckStatusChange: function nodeCheckStatusChange() {
      var treeNodes = this.$refs.dropTree.getCheckedNodes(true);
      if (!treeNodes) this.selectedItems = [];
      this.selectedItems = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = treeNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var node = _step.value;

          this.selectedItems.push(node.title);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },


    /*
    * search nodes from  drop-down tree
    * */
    searchNodes: function searchNodes() {
      var filter = this.searchFilter ? this.searchFilter : this.searchword;
      this.$refs.dropTree.searchNodes(filter);
    },


    // click tag animation effects
    tagClick: function tagClick(e) {
      var l = e.target.offsetLeft - 5;
      this.$refs.txtbox.style.transition = 'transform .3s linear';
      this.$refs.txtbox.style.transform = 'translateX(-' + l + 'px)';
    },


    // remove tag animation effects
    leaveTextTag: function leaveTextTag() {
      this.$refs.txtbox.style.transition = 'transform 0.4s';
      this.$refs.txtbox.style.transform = 'translateX(0)';
    },

    /*
    * @param data source tree data
    * initialize the state of the drop-down tree node
    */
    initTreeStatus: function initTreeStatus(data) {
      var _this2 = this;

      data = data || this.data;

      var _loop = function _loop(node) {
        if (_this2.value.findIndex(function (text) {
          return text === node.title;
        }) > -1) {
          _this2.$set(node, 'selected', true);
          _this2.$set(node, 'checked', true);
        }
        if (node.children && node.children.length) {
          _this2.initTreeStatus(node.children);
        }
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var node = _step2.value;

          _loop(node);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    getTreeRef: function getTreeRef() {
      return this.$refs.dropTree;
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tree__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectTree__ = __webpack_require__(20);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VTree", function() { return __WEBPACK_IMPORTED_MODULE_0__tree__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSelectTree", function() { return __WEBPACK_IMPORTED_MODULE_1__selectTree__["a"]; });


__WEBPACK_IMPORTED_MODULE_0__tree__["a" /* default */].install = function (Vue) {
  Vue.component('VTree', __WEBPACK_IMPORTED_MODULE_0__tree__["a" /* default */]);
};

__WEBPACK_IMPORTED_MODULE_1__selectTree__["a" /* default */].install = function (Vue) {
  Vue.component('VSelectTree', __WEBPACK_IMPORTED_MODULE_1__selectTree__["a" /* default */]);
};



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__tree__["a" /* default */]);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_treeLi_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2981a7e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_treeLi_vue__ = __webpack_require__(17);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_treeLi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2981a7e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_treeLi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'render',
  functional: true,
  props: {
    node: Object,
    parent: null,
    tpl: Function,
    index: Number,
    nodeMouseOver: Function,
    level: Number
  },
  render: function render(h, ctx) {
    var _ctx$props = ctx.props,
        node = _ctx$props.node,
        parent = _ctx$props.parent,
        tpl = _ctx$props.tpl,
        index = _ctx$props.index,
        nodeMouseOver = _ctx$props.nodeMouseOver,
        level = _ctx$props.level;
    var selected = node.selected,
        _node$selDisabled = node.selDisabled,
        selDisabled = _node$selDisabled === undefined ? false : _node$selDisabled;

    var titleClass = void 0;
    if (selDisabled) {
      titleClass = 'node-title-disabled';
    } else {
      titleClass = selected ? 'node-title node-selected' : 'node-title';
    }
    if (node.searched) titleClass += ' node-searched';
    return tpl ? tpl(node, ctx, parent, index, ctx.props) : h('span', {
      domProps: {
        'innerHTML': node.title
      },
      attrs: { title: node.title },
      'class': titleClass,
      on: {
        'mouseover': function mouseover() {
          return nodeMouseOver(node, index, parent);
        },
        'click': function click() {
          if (selDisabled) return;
          ctx.parent.nodeSelected(node, { level: level, index: index });
        }
      },

      style: 'user-select: none'
    });
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7743bdc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__(15);
function injectStyle (ssrContext) {
  __webpack_require__(14)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7743bdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7743bdc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 120 120","version":"1.1"}},[_c('g',{staticClass:"g-circles g-circles--v3",attrs:{"id":"circle"}},[_c('circle',{attrs:{"id":"12","transform":"translate(35, 16.698730) rotate(-30) translate(-35, -16.698730) ","cx":"35","cy":"16.6987298","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"11","transform":"translate(16.698730, 35) rotate(-60) translate(-16.698730, -35) ","cx":"16.6987298","cy":"35","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"10","transform":"translate(10, 60) rotate(-90) translate(-10, -60) ","cx":"10","cy":"60","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"9","transform":"translate(16.698730, 85) rotate(-120) translate(-16.698730, -85) ","cx":"16.6987298","cy":"85","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"8","transform":"translate(35, 103.301270) rotate(-150) translate(-35, -103.301270) ","cx":"35","cy":"103.30127","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"7","cx":"60","cy":"110","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"6","transform":"translate(85, 103.301270) rotate(-30) translate(-85, -103.301270) ","cx":"85","cy":"103.30127","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"5","transform":"translate(103.301270, 85) rotate(-60) translate(-103.301270, -85) ","cx":"103.30127","cy":"85","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"4","transform":"translate(110, 60) rotate(-90) translate(-110, -60) ","cx":"110","cy":"60","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"3","transform":"translate(103.301270, 35) rotate(-120) translate(-103.301270, -35) ","cx":"103.30127","cy":"35","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"2","transform":"translate(85, 16.698730) rotate(-150) translate(-85, -16.698730) ","cx":"85","cy":"16.6987298","r":"10"}}),_vm._v(" "),_c('circle',{attrs:{"id":"1","cx":"60","cy":"10","r":"10"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var Transition = {
  'before-enter': function beforeEnter(el) {
    // _dom.addClass(el, 'wz-animate')
    if (!el.dataset) el.dataset = {};

    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;

    el.style.height = '0';
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
  },
  'enter': function enter(el) {
    el.dataset.oldOverflow = el.style.overflow;
    if (el.scrollHeight !== 0) {
      el.style.height = el.scrollHeight + 'px';
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    } else {
      el.style.height = '';
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    }
    el.style.overflow = 'hidden';
  },
  'after-enter': function afterEnter(el) {
    // for safari: remove class then reset height is necessary
    // _dom.removeClass(el, 'wz-animate')
    el.style.height = '';
    el.style.overflow = el.dataset.oldOverflow;
  },
  'before-leave': function beforeLeave(el) {
    if (!el.dataset) el.dataset = {};
    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;
    el.dataset.oldOverflow = el.style.overflow;

    el.style.height = el.scrollHeight + 'px';
    el.style.overflow = 'hidden';
  },
  'leave': function leave(el) {
    if (el.scrollHeight !== 0) {
      // for safari: add class after set height, or it will jump to zero height suddenly, weired
      // (0, _dom.addClass)(el, 'wz-animate')
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
    }
  },
  'after-leave': function afterLeave(el) {
    // _dom.removeClass(el, 'wz-animate')
    el.style.height = '';
    el.style.overflow = el.dataset.oldOverflow;
    el.style.paddingTop = el.dataset.oldPaddingTop;
    el.style.paddingBottom = el.dataset.oldPaddingBottom;
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CollapseTransition',
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children;

    var data = {
      on: Transition
    };
    return h('transition', data, children);
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.itemVisible)?_c('li',{class:_vm.liClass},[_c('div',{staticClass:"tree-node-el",attrs:{"draggable":_vm.draggable},on:{"dragstart":function($event){_vm.drag(_vm.item, $event)}}},[(_vm.showExpand)?_c('span',{staticClass:"tree-expand",class:_vm.item.expanded ? 'tree-open' : 'tree-close',on:{"click":function($event){_vm.expandNode(_vm.item)}}}):_vm._e(),_vm._v(" "),(_vm.multiple && !_vm.item.nocheck)?_c('span',{staticClass:"inputCheck",class:_vm.spanInputClass},[(_vm.multiple)?_c('input',{class:['check', _vm.item.chkDisabled ? 'chkDisabled' : ''],attrs:{"disabled":_vm.item.chkDisabled,"type":"checkbox"},domProps:{"checked":_vm.checkboxChecked},on:{"change":function($event){_vm.changeNodeCheckStatus(_vm.item, $event)}}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.item.loading && _vm.item.expanded)?_c('loading'):_vm._e(),_vm._v(" "),_c('Render',{attrs:{"node":_vm.item,"parent":_vm.parent,"index":_vm.index,"tpl":_vm.tpl,"nodeMouseOver":_vm.nodeMouseOver,"level":_vm.level}})],1),_vm._v(" "),(_vm.showNextUl)?[_c('collapse-transition',[_c('TreeUl',{directives:[{name:"show",rawName:"v-show",value:(_vm.item.expanded),expression:"item.expanded"}],attrs:{"dragAfterExpanded":_vm.dragAfterExpanded,"draggable":_vm.draggable,"tpl":_vm.tpl,"data":_vm.item.children,"halfcheck":_vm.halfcheck,"scoped":_vm.scoped,"parent":_vm.item,"canDeleteRoot":_vm.canDeleteRoot,"multiple":_vm.multiple,"level":_vm.level,"maxLevel":_vm.maxLevel,"topMustExpand":_vm.topMustExpand,"allowGetParentNode":_vm.allowGetParentNode}})],1)]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"halo-tree"},_vm._l((_vm.data),function(item,index){return _c('treeLi',_vm._b({key:item.id ? item.id : index,attrs:{"item":item,"index":index},nativeOn:{"drop":function($event){$event.stopPropagation();_vm.drop(item, $event)},"dragover":function($event){$event.stopPropagation();return _vm.dragover($event)}}},'treeLi',_vm.childBind,false))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TreeUl',_vm._b({},'TreeUl',_vm.childBind,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectTree_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bc45e7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectTree_vue__ = __webpack_require__(22);
function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bc45e7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-container"},[_c('div',{staticClass:"tag-box-container"},[_c('div',{ref:"txtbox",staticClass:"tag-box",on:{"click":function($event){_vm.open = !_vm.open},"mouseleave":_vm.leaveTextTag}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selectedItems.length),expression:"!selectedItems.length"}],staticClass:"tag blank"},[_vm._v(_vm._s(_vm.pleasechoosetext))]),_vm._v(" "),_vm._l((_vm.selectedItems),function(node,idx){return _c('div',{key:idx,ref:"txttag",refInFor:true,staticClass:"tag",on:{"click":function($event){$event.stopPropagation();_vm.tagClick($event)}}},[_vm._v("\n         "+_vm._s(node)+"\n         "),_c('span',{staticClass:"rmNode",on:{"click":function($event){$event.stopPropagation();_vm.rmNode(node)}}},[_vm._v("x")])])})],2)]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],staticClass:"tree-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchword),expression:"searchword"},{name:"show",rawName:"v-show",value:(_vm.searchable),expression:"searchable"}],staticClass:"search-input",attrs:{"type":"text","placeholder":_vm.searchtext},domProps:{"value":(_vm.searchword)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchNodes($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchword=$event.target.value}}}),_vm._v(" "),_c('v-tree',_vm._g(_vm._b({ref:"dropTree",attrs:{"data":_vm.data,"dragAfterExpanded":_vm.dragAfterExpanded,"draggable":_vm.draggable,"tpl":_vm.tpl,"multiple":_vm.multiple},on:{"dropTreeNodeChecked":_vm.nodeCheckStatusChange,"async-load-nodes":_vm.asyncLoadNodes,"node-expanded":_vm.asyncLoadNodes,"node-click":_vm.nodeClick,"node-check":_vm.nodeClick}},'v-tree',_vm.vTreeObj,false),_vm.$listeners))],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// v2-tree.js